<template>
  <div>
    <a-list :loading="loading" :data-source="logs">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta>
          <div slot="title">
            <a-tooltip
              placement="topLeft"
              :title="item.action"
              style="margin-right: 10px;"
            >
              <a-icon
                v-if="item.action === 'ADD'"
                type="plus-circle"
                :style="{ color: 'green' }"
              />
              <a-icon
                v-else-if="item.action === 'DELETE'"
                type="delete"
                :style="{ color: 'red' }"
              />
              <a-icon
                v-else-if="item.action === 'EDIT'"
                type="edit"
                :style="{ color: 'blue' }"
              />
            </a-tooltip>
            {{ item.createdAt | formatDateHour }} -
            <span v-if="item.author">
              {{ item.author.fullname || item.author.username }}
            </span>
          </div>
          <div slot="description">
            <!-- hiển thị cho work leave day -->
            <div v-if="item.target === 'WorkLeaveDay'">
              <a-descriptions style="margin-top: 10px;" :column="2">
                <a-descriptions-item label="Start Date">
                  {{ parseItem(item.after).startDate | formatDateHour }}
                </a-descriptions-item>
                <a-descriptions-item label="End Date">
                  {{ parseItem(item.after).endDate | formatDateHour }}
                </a-descriptions-item>
                <a-descriptions-item label="Total Days">
                  {{ parseItem(item.after).totalLeaveDays | numParseFloat(2) }}
                </a-descriptions-item>
                <a-descriptions-item label="Total Hours">
                  {{ parseItem(item.after).totalLeaveHours | numParseFloat(2) }}
                </a-descriptions-item>
              </a-descriptions>
              <div class="top-advance" v-if="item.action === 'EDIT'">
                <a-button
                  v-if="item.id !== viewOld"
                  icon="double-right"
                  type="link"
                  style="border: 0; width: 100%; text-align: left; padding: 0;"
                  @click="viewOld = item.id"
                >
                  View information before editing
                </a-button>
                <div class="top-old-log" v-else>
                  <a-divider dashed />
                  <a-alert
                    type="warning"
                    closable
                    @close="() => (viewOld = '')"
                  >
                    <div slot="description">
                      <a-descriptions style="margin-top: 10px;" :column="2">
                        <a-descriptions-item label="Start Date">
                          <span
                            :class="
                              setClassForOld(
                                parseItem(item.before).startDate,
                                parseItem(item.after).startDate
                              )
                            "
                          >
                            {{
                              parseItem(item.before).startDate | formatDateHour
                            }}
                          </span>
                        </a-descriptions-item>
                        <a-descriptions-item label="End Date">
                          <span
                            :class="
                              setClassForOld(
                                parseItem(item.before).endDate,
                                parseItem(item.after).endDate
                              )
                            "
                          >
                            {{
                              parseItem(item.before).endDate | formatDateHour
                            }}
                          </span>
                        </a-descriptions-item>
                        <a-descriptions-item label="Total Days">
                          <span
                            :class="
                              setClassForOld(
                                parseItem(item.before).totalLeaveDays,
                                parseItem(item.after).totalLeaveDays
                              )
                            "
                          >
                            {{
                              parseItem(item.before).totalLeaveDays
                                | numParseFloat(2)
                            }}
                          </span>
                        </a-descriptions-item>
                        <a-descriptions-item label="Total Hours">
                          <span
                            :class="
                              setClassForOld(
                                parseItem(item.before).totalLeaveHours,
                                parseItem(item.after).totalLeaveHours
                              )
                            "
                          >
                            {{
                              parseItem(item.before).totalLeaveHours
                                | numParseFloat(2)
                            }}
                          </span>
                        </a-descriptions-item>
                      </a-descriptions>
                    </div>
                  </a-alert>
                </div>
              </div>
            </div>

            <!-- hiểnthị cho work leave -->
            <div v-if="item.target === 'WorkLeave'">
              <a-descriptions style="margin-top: 10px;" :column="2">
                <a-descriptions-item label="Total Days">
                  {{ parseItem(item.after).totalLeaveDays | numParseFloat(2) }}
                </a-descriptions-item>
                <a-descriptions-item label="Total Hous">
                  {{ parseItem(item.after).totalLeaveHours | numParseFloat(2) }}
                </a-descriptions-item>
              </a-descriptions>
              <section class="highlight-wrapper">
                <p style="color: #777; font-size: 15px;">Content</p>
                <div
                  v-if="parseItem(item.after).description"
                  class="top-descriptions ql-editor"
                  v-html="parseItem(item.after).description"
                  style="padding: 0px;"
                ></div>
              </section>
              <div class="top-advance" v-if="item.action === 'EDIT'">
                <a-button
                  v-if="item.id !== viewOld"
                  icon="double-right"
                  type="link"
                  style="border: 0; width: 100%; text-align: left; padding: 0;"
                  @click="viewOld = item.id"
                >
                  View information before editing
                </a-button>
                <div class="top-old-log" v-else>
                  <a-divider dashed />
                  <a-alert
                    type="warning"
                    closable
                    @close="() => (viewOld = '')"
                  >
                    <div slot="description">
                      <a-descriptions :column="2">
                        <a-descriptions-item label="Total Days">
                          <span
                            :class="
                              setClassForOld(
                                parseItem(item.before).totalLeaveDays,
                                parseItem(item.after).totalLeaveDays
                              )
                            "
                          >
                            {{
                              parseItem(item.before).totalLeaveDays
                                | numParseFloat(2)
                            }}
                          </span>
                        </a-descriptions-item>
                        <a-descriptions-item label="Total Hours">
                          <span
                            :class="
                              setClassForOld(
                                parseItem(item.before).totalLeaveHours,
                                parseItem(item.after).totalLeaveHours
                              )
                            "
                          >
                            {{
                              parseItem(item.before).totalLeaveHours
                                | numParseFloat(2)
                            }}
                          </span>
                        </a-descriptions-item>
                      </a-descriptions>
                      <section class="highlight-wrapper">
                        <p style="color: #777; font-size: 15px;">Content</p>
                        <div
                          v-if="parseItem(item.before).description"
                          class="top-descriptions ql-editor"
                          v-html="parseItem(item.before).description"
                          style="padding: 0px;"
                        ></div>
                      </section>
                    </div>
                  </a-alert>
                </div>
              </div>
            </div>
          </div>
        </a-list-item-meta>
      </a-list-item>
    </a-list>
    <div v-if="isPagination" style="text-align: center; margin-top: 20px;">
      <a-button
        type="primary"
        icon="sync"
        @click="onGetListDataMore"
        :loading="loading"
      >
        Xem thêm
      </a-button>
    </div>
  </div>
</template>
<script>
import gql from "graphql-tag";
const query = gql`
  query($workLeaveId: ID!) {
    getListWorkLeaveHrChangeLogByWorkLeaveId(workLeaveId: $workLeaveId) {
      id
      action
      target
      before
      after
      workLeaveId
      workLeaveRefId
      workLeaveDayId
      workLeaveDayRefId
      workLeaveDay {
        id
        startDate
        endDate
        totalLeaveDays
        totalLeaveHours
      }
      createdAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

function parseItem(item) {
  if (item) {
    return JSON.parse(item);
  }
  return {};
}

function setClassForOld(oldItem, newItem) {
  return oldItem !== newItem ? "is-changed" : "";
}

const limit = 10;
const startPage = 1;

export default {
  components: {},
  props: {
    workLeaveId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logs: [],
      page: startPage,
      loading: false,
      isPagination: false,
      viewOld: "",
    };
  },
  mounted() {
    this.onGetListData();
  },
  methods: {
    parseItem,
    setClassForOld,
    onInitGetListData(callBack) {
      this.loading = true;
      this.$apollo
        .query({
          query,
          variables: {
            limit,
            page: this.page,
            workLeaveId: this.workLeaveId,
            targets: ["WorkOvertimeDetail"],
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getListWorkLeaveHrChangeLogByWorkLeaveId?.length >= 0) {
            if (typeof callBack === "function") {
              callBack(data.getListWorkLeaveHrChangeLogByWorkLeaveId);
            }
            if (
              data.getListWorkLeaveHrChangeLogByWorkLeaveId.length === limit
            ) {
              this.isPagination = true;
            } else {
              this.isPagination = false;
            }
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Lỗi lấy danh sách!",
          });
        });
    },
    onGetListData() {
      this.onInitGetListData((datas) => {
        this.logs = [...datas];
      });
    },
    onGetListDataMore() {
      this.page += 1;
      this.onInitGetListData((datas) => {
        this.logs = this.logs.concat([...datas]);
      });
    },
  },
};
</script>
<style lang="css" scoped>
.is-changed {
  color: red;
}
.top-descriptions {
  white-space: pre-line;
}
.highlight-wrapper {
  position: relative;
  border-radius: 0 0 2px 2px;
  border-top: 1px dashed #ebedf0;
  padding: 10px 0;
}
</style>
